module.exports = __webpack_public_path__ + "img/igin.3b3e526a.png";